import styles from './last-updated.module.scss';
import classNames from 'classnames';
import {Icon} from '@udemy-v2/icons';
import {useFormatDate, useI18n} from '@udemy-v2/i18n';
import {useClpCourse} from '../../context/clp-course-provider.react-component';

/**
 * Component that displays when a course was last updated
 * Shows a calendar icon with "Last updated <date>" text
 */
export const LastUpdated = () => {
    const course = useClpCourse();
    const {toLocaleDateString} = useFormatDate();
    const {gettext, interpolate} = useI18n();

    if (!course.updatedOn) {
        return null;
    }

    const dateObj = new Date(course.updatedOn);
    const formattedDate = toLocaleDateString(dateObj, {
        year: 'numeric',
        month: 'numeric',
        timeZone: 'UTC',
    });
    const lastUpdatedText = interpolate(
        gettext('Last updated %(date)s'),
        {date: formattedDate},
        true,
    );

    return (
        <div className={classNames(styles['last-updated'], 'ud-text-sm')}>
            <Icon glyph="calendar-30" size="xsmall" label={lastUpdatedText} />
            <span>{lastUpdatedText}</span>
        </div>
    );
};
